export default [
    {
        name: 'environmentMapTexture',
        type: 'cubeTexture',
        path:
        [
            'https://viewer-dev.zipcpq.com/textures/Standard-Cube-Map/px.png',
            'https://viewer-dev.zipcpq.com/textures/Standard-Cube-Map/nx.png',
            'https://viewer-dev.zipcpq.com/textures/Standard-Cube-Map/py.png',
            'https://viewer-dev.zipcpq.com/textures/Standard-Cube-Map/ny.png',
            'https://viewer-dev.zipcpq.com/textures/Standard-Cube-Map/pz.png', 
            'https://viewer-dev.zipcpq.com/textures/Standard-Cube-Map/nz.png'
        ]
    },
    {
        name: 'grassColorTexture',
        type: 'texture',
        path: 'https://viewer-dev.zipcpq.com/textures/dirt/color.jpg'
    },
    {
        name: 'grassNormalTexture',
        type: 'texture',
        path: 'https://viewer-dev.zipcpq.com/textures/dirt/normal.jpg'
    },
  

    {
        name: 'object',
        type: 'glbModel',
        path: 'https://viewer-dev.zipcpq.com/models/ConwayMachine/6500711.glb',
    }]